/**
 * Utility functions to extract EEC and envkv label data from the new mediaItems structure
 * as described in WEBART-15188
 */

export interface TechnicalDataMediaItem {
	key: string;
	src: string;
	altText?: string | null;
}

/**
 * Extract EEC label URL from mediaItems
 * Looks for 'eec-label-url' key in the mediaItems array
 */
export function getEecLabelUrl(mediaItems?: TechnicalDataMediaItem[] | null): string | null {
	if (!mediaItems) return null;

	const eecItem = mediaItems.find((item) => item.key === 'eec-label-url');
	return eecItem?.src || null;
}

/**
 * Extract envkv label SVG URL from mediaItems
 * Looks for 'envkv-label-svg-url' key in the mediaItems array
 */
export function getEnvkvLabelSvgUrl(mediaItems?: TechnicalDataMediaItem[] | null): string | null {
	if (!mediaItems) return null;

	const envkvSvgItem = mediaItems.find((item) => item.key === 'envkv-label-svg-url');
	return envkvSvgItem?.src || null;
}

/**
 * Extract envkv label PDF URL from mediaItems
 * Looks for 'envkv-label-pdf-url' key in the mediaItems array
 */
export function getEnvkvLabelPdfUrl(mediaItems?: TechnicalDataMediaItem[] | null): string | null {
	if (!mediaItems) return null;

	const envkvPdfItem = mediaItems.find((item) => item.key === 'envkv-label-pdf-url');
	return envkvPdfItem?.src || null;
}

/**
 * Extract all envkv related URLs from mediaItems
 * Returns an object with both SVG and PDF URLs
 */
export function getEnvkvLabelUrls(mediaItems?: TechnicalDataMediaItem[] | null): {
	svgUrl: string | null;
	pdfUrl: string | null;
} {
	return {
		svgUrl: getEnvkvLabelSvgUrl(mediaItems),
		pdfUrl: getEnvkvLabelPdfUrl(mediaItems),
	};
}

/**
 * Extract EEC label with alt text from mediaItems
 * Returns an object with URL and alt text
 */
export function getEecLabelData(mediaItems?: TechnicalDataMediaItem[] | null): {
	url: string | null;
	altText: string | null;
} {
	if (!mediaItems) return { url: null, altText: null };

	const eecItem = mediaItems.find((item) => item.key === 'eec-label-url');
	return {
		url: eecItem?.src || null,
		altText: eecItem?.altText || null,
	};
}
